import React from 'react';
import classnames from 'classnames';
import { I18n } from '@fiverr-private/i18n-react';
import { useSellerData } from '../../hooks/useSellerData';
import { FederatedSeller } from '../../types';
import { RespondTimeInfoProps } from './types';

const T_PREFIX = 'seller_pages_toolbox.contact';

const getRespondTimeText = (hours: number) =>
    hours === 1 ? `${T_PREFIX}.responds_in_hour` : `${T_PREFIX}.responds_in_hours`;

export const RespondTimeInfo = ({ className }: RespondTimeInfoProps) => {
    const { responseTime } = useSellerData(selectSellerSlice);
    const inHours = responseTime?.inHours;

    if (!inHours) {
        return null;
    }

    return (
        <div className={classnames(className, 'flex flex-center responds-info')}>
            <span>
                <I18n k={getRespondTimeText(inHours)} params={{ hour: inHours }} />
            </span>
        </div>
    );
};

function selectSellerSlice(seller: FederatedSeller) {
    return {
        responseTime: seller.responseTime,
    };
}
